module.exports = __webpack_public_path__ + "static/media/Delay Modeler Mid Gain VR.30a00f9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/modeler/Delay Modeler Mid Gain VR.mp3
// module id = 8oj2
// module chunks = 12